import { API_END_POINT } from "../../../constants";
import { Button, Modal } from "react-bootstrap";
import "@progress/kendo-theme-default/dist/all.css";
import "../../../components/Style/ProductInvoiceStyle.css";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { OrderHistory } from "../../../models/transaction/orderhistory-model";
import {
    getDataWithToken,
    getEndPoint,
    postData,
} from "../../../Utils/network.client";
import { Product, Receipt } from "../../../models/transaction/cardorder-model";
import { useGetPaymentMode } from "../../../apiclient/common/useGetPaymentModeApi";
import {
    useGetSessionForProductInv,
    useGetSubGroupProductInvoice,
} from "../../../apiclient/transaction/useGetSubGroupProductInvoiceApi";
import { SubGroupWiseProduct } from "../../../models/transaction/productinvoice-model";
import EditIcon, { MinusIcon, PlusIcon } from "../../../assets/images/edit";
import { DateFilter } from "@progress/kendo-react-data-tools";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import DeleteIcon from "../../../assets/images/delete";
import DatePicker from "react-datepicker";
import dayjs from "dayjs";
import { formatDate } from "@progress/kendo-intl";
import ProductInvoiceHistoryPage from "./productinvoicehistory.page";
import ProductInvoiceHistoryModel from "../../../models/transaction/productinvoicehistory-model";
const html2pdf = require("html2pdf.js");

interface ProductInvoiceEditProps {
    data: ProductInvoiceHistoryModel;
    onClose?: () => void;
    setActivePage: (page: "list" | "entry") => void; // Function to change active page
}

const ProductInvoiceEntryPage: React.FC<ProductInvoiceEditProps> = ({
    data,
    setActivePage,
}) => {
    const location = useLocation();
    const zoneData = data;

    console.log("Zone", zoneData);

    let orderZoneId = zoneData.zoneId;
    let orderCounterId = zoneData.counterId;
    let droppingPointCode = zoneData.droppingPointCode;
    let invMainId = zoneData.productInvoiceMainId;
    let receiptId = zoneData.receiptId;

    //product invoice
    const [productInvoiceHtml, setProductInvoiceHtml] = useState("");
    const [loadingDetails, setLoadingDetails] = useState<boolean>(false);
    const [customerCode, setCustomerCode] = useState<string>("");
    const [showModal, setShowModal] = useState(false);
    /*   const [orderDate, setOrderDate] = useState<string>(""); */
    const [agentId, setAgentId] = useState(0);
    const [droppingpointid, setdroppingpointid] = useState(0);
    const [productInvoiceMainId, setproductInvoiceMainId] = useState(0);
    const navigate = useNavigate();
    const [fetchedCardProductList, setFetchedCardProductList] = useState<
        Product[]
    >([]);
    const [totalAmount, setTotalAmount] = useState<number>(0);
    const [orderNumber, setorderNumber] = useState<string>("");
    const [isDespatched, setisDespatched] = useState(false);
    const [discountAmount, setdiscountAmount] = useState(0);
    //receipt
    const [reference, setReference] = useState("");
    const [receivedAmount, setReceivedAmount] = useState('');
    //session
    const [sessionId, setSessionId] = useState<number>(0);
    const [sessionList, setSessionList] = useState<
        { value: string; label: string }[]
    >([]);
    const { data: fetchedSession } = useGetSessionForProductInv();
    console.log("fetchedSession", fetchedSession);
    //subgroup dropdown
    const [subGroupList, setSubGroupList] = useState<
        { value: string; label: string }[]
    >([]);
    const { data: fetchedSubGroup } = useGetSubGroupProductInvoice();
    console.log("fetchedSubGroup", fetchedSubGroup);
    const [subGroupId, setSubGroupId] = useState<number>(0);
    const [subGroupProductList, setSubGroupProductList] = useState<
        SubGroupWiseProduct[]
    >([]);
    const [productList, setProductList] = useState([]);
    const [addedProducts, setAddedProducts] = useState(new Set());
    /*    const [expandedSubgroup, setExpandedSubgroup] = useState(null); */
    const [showBrowsePage, setShowBrowsePage] = useState(false);
     const [showSave, setSave] = useState(false);
    //popup
    const [modalTitle, setModalTitle] = useState<string>("");
    const [modalLine1, setModalLine1] = useState("");
    const [modalLine2, setModalLine2] = useState("");
    const [isUpdateMode, setIsUpdateMode] = useState(false);

    // mode payment for dropdown
    const [modeOfPayment, setModeOfPayment] = useState<number>(0);
    const [modePayment, setmodePaymentData] = useState<
        { value: string; label: string }[]
    >([]);
    const { data: fetchedModePayment } = useGetPaymentMode();

    const [page, setPage] = useState({ skip: 0, take: 10 });
    const [subGroupPage, setSubGroupPage] = useState({ skip: 0, take: 10 });
    useEffect(() => {
        setSubGroupPage({ skip: 0, take: 10 });
    }, [subGroupProductList]);

    useEffect(() => {
        if (droppingPointCode) {          
            setCustomerCode(droppingPointCode);
            setSessionId(zoneData.sessionId);
            setOrderDate(zoneData.orderDate2);
            setdroppingpointid(zoneData.droppingPointId);
            setAgentId(zoneData.agentId);
            setProductList(zoneData.productInvoiceLineDetailsParsed);
            setOrderDate(zoneData.orderDate2);
            setReceivedAmount(zoneData.receivedAmount.toFixed(2));
            setReference(zoneData.reference);
            setModeOfPayment(zoneData.paymentMode);
            const added = new Set(zoneData.productInvoiceLineDetailsParsed.map((product: any) => product.code));
            setAddedProducts(added);
            setSave(true);     
        }
    }, [droppingPointCode]);

    useEffect(() => {
        if (fetchedSubGroup) {
            const mappedsubgroup = fetchedSubGroup.map((subgroups: any) => ({
                value: subgroups.subGroupId,
                label: subgroups.subGroupName,
            }));
            setSubGroupList(mappedsubgroup);
        }
        if (fetchedSession) {
            const mappedsession = fetchedSession.map((sessions: any) => ({
                value: sessions.sessionId,
                label: sessions.name,
            }));
            setSessionList(mappedsession);
        }
        if (fetchedModePayment) {
            const mappedmodepayment = fetchedModePayment.map((modepayment: any) => ({
                value: modepayment.id,
                label: modepayment.name,
            }));
            setmodePaymentData(mappedmodepayment);
        }
    }, [fetchedSubGroup, fetchedSession, fetchedModePayment]);

    const handleModedropdownChange = (event: { target: { value: any } }) => {
        setModeOfPayment(event.target.value);
        // alert(event.target.value) // Update selected option
    };

    const handleClose = () => {
        navigate("/ProductInvoice");
    };

    //new

    const [orderDate, setOrderDate] = useState<Date>(
        new Date(dayjs().add(0, "months").format("MM/DD/YYYY"))
    );
    const [orderDate2, setOrderDate2] = useState<string>("");
    const [deliveryDate, setDeliveryDate] = useState<Date>(
        new Date(dayjs().add(0, "months").format("MM/DD/YYYY"))
    );
    const [deliveryDate2, setDeliveryDate2] = useState<string>("");

    const handleDateChange = (value: any) => {
        // const today = new Date();
        const day = value.getDate().toString().padStart(2, "0");
        const month = value
            .toLocaleString("default", { month: "short" })
            .toUpperCase(); // Get short month (e.g., JAN)
        const year = value.getFullYear();
        const formattedDate = new Date(`${year}-${month}-${day}`);
        setOrderDate(formattedDate);
    };
    useEffect(() => {
        if (orderDate) {
            const formattedDate1 = dayjs(orderDate).format("ddd MMM DD YYYY ");
            console.log("Formatted Date:", formattedDate1);
            setOrderDate2(formattedDate1);
        }
        if (deliveryDate) {
            const formattedDate2 = dayjs(deliveryDate).format("ddd MMM DD YYYY ");
            // console.log("Formatted Date:", formattedDate2);
            setDeliveryDate2(formattedDate2);
        }
    }, [orderDate, deliveryDate]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        if (name === "customerCode") {
            setCustomerCode(value);
        } else if (name === "reference") {
            setReference(value);
        } else if (name === "receivedAmount") {
            setReceivedAmount(value);
        }
    };

    const handlesessiondropdownChange = (event: { target: { value: any } }) => {
        setSessionId(event.target.value);
        console.log("sessionId", event.target.value);
    };

    const handleEditBrowse = () => {
        //navigate('/ProductInvoiceHistoryPage');
        setShowBrowsePage(true);
        // <ProductInvoiceHistoryPage  />
        setShowModal(false);
    };

    const handlesubgroupdropdownChange = (event: { target: { value: any } }) => {
        setSubGroupId(event.target.value);
        console.log("subGroupId", event.target.value);
        getSubGroupWiseProductList(event.target.value, orderDate2, customerCode);
    };

    const getSubGroupWiseProductList = async (
        subGroupId: number,
        date: string,
        customerCode: string
    ) => {
        console.log("subGroupId1", subGroupId);

        if (subGroupId != 0) {
            if (customerCode) {
                const getSubGroupProdudtUrl =
                    getEndPoint(API_END_POINT.ORDER) +
                    `/api/ProductInvoice/GetProductsBySubGroup/${subGroupId}/${date}/${customerCode}`; // Base URL
                try {
                    const response = await getDataWithToken<any>(getSubGroupProdudtUrl);

                    const subGroupProductDetails = response?.data?.result;
                    console.log("subGroupProductDetails", subGroupProductDetails);
                    if (subGroupProductDetails.length > 0) {
                        setSubGroupProductList(subGroupProductDetails);
                        const subGrpProdLidt = subGroupProductDetails[0];
                        setAgentId(subGrpProdLidt?.agentId);
                        setdroppingpointid(subGrpProdLidt?.droppingPointId);
                    } else {
                        alert("Code Does not exist");
                        setSubGroupProductList([]);
                    }
                } catch (error) {
                    console.error("Error fetching data:", error);
                    //setShowGrid(false);
                }
            } else {
                alert("Please Select a Code");
            }
        }
        else {
            alert("Please Select a SubGroup")
        }

    };

    const handleAddButtonClick = (props: any) => {
        console.log("props:", props);
        console.log("add", addedProducts);
        const newAddedProducts = new Set(addedProducts);
        console.log("addnew", newAddedProducts);
        //alert(newAddedProducts.has(props.code));
        if (newAddedProducts.has(props.code)) {
            setProductList(productList.filter(item => item.code !== props.code));
            newAddedProducts.delete(props.code);
        } else {
            const newProduct = {
                ...props,
                qty: "",
                amount: "0",
                cGst: "0",
                sGst: "0",
                iGst: "0"
            };
            setProductList([...productList, newProduct]);
            newAddedProducts.add(props.code);
            // setProductList([...productList, props]);
            // newAddedProducts.add(props.code);
        }
        setAddedProducts(newAddedProducts); // Update the added products set
    };

    // console.log('produ', productList);

    const handleRemoveProduct = (indexToRemove: number) => {
        //setProductList(prevList => prevList.filter((_, index) => index !== indexToRemove));
        const removedProduct = productList[indexToRemove];
        const updatedProductList = productList.filter(
            (_, index) => index !== indexToRemove
        );
        const updatedAddedProducts = new Set(addedProducts);
        console.log("updatedAddedProducts", updatedAddedProducts);
        updatedAddedProducts.delete(removedProduct.code);
        setProductList(updatedProductList);
        setAddedProducts(updatedAddedProducts);
    };

    const handleEditFromHistory = (invoiceData: ProductInvoiceHistoryModel) => {
        // Handle the edit action, e.g., set data and switch to entry page
        // You can set the data to state if needed
        setActivePage("entry"); // Switch to entry page
    };

    const handleQtyChange = (
        e: React.ChangeEvent<HTMLInputElement>,
        index: number,
        type: string
    ) => {
        const updatedList = [...productList];
        const updatedItem = updatedList[index];

        let value = Number(e.target.value);
        if (isNaN(value) || value < 0) {
            value = 0; // Set to 0 if invalid or negative
        }
        if (type === "qty") {
            updatedItem.qty = value;
        }
        updatedItem.amount =
            Number(updatedItem.qty) * Number(updatedItem.basicRate);
        if (updatedItem.isOtherState == false) {
            updatedItem.cGst = Number(updatedItem.qty) * Number(updatedItem.cgstRate);
            updatedItem.sGst = Number(updatedItem.qty) * Number(updatedItem.sgstRate);
        } else {
            updatedItem.iGst = Number(updatedItem.qty) * Number(updatedItem.igstRate);
        }
        updatedList[index] = updatedItem;
        setProductList(updatedList);
        calculateTotalAmount(updatedList);
    };

    const calculateTotalAmount = (data: any[]) => {
        console.log("Data:", data);
        const total = data.reduce((sum, item) => {
            const amount = parseFloat(item.amount);
            console.log("sum:", amount);
            return sum + (isNaN(amount) ? 0 : amount);
        }, 0);
        console.log("total a:", total);
        setTotalAmount(total);
        setReceivedAmount(total.toFixed(2));
    };
    // console.log("prods", productList);

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleRowClick = (event: any) => {
        const updated = productList.map((item) =>
            item.productId === event.dataItem.productId
                ? { ...item, inEdit: true }
                : { ...item, inEdit: false }
        );
        setProductList(updated);
    };


    const handleItemChange = (e: any) => {
        const updated = [...productList];
        const index = updated.findIndex((item) => item.productId === e.dataItem.productId);

        if (index !== -1) {
            const field = e.field;
            const value = Number(e.value) >= 0 ? Number(e.value) : 0;
            const currentItem = { ...updated[index], [field]: value };
            currentItem.qty = field === 'qty' ? value/* Math.min(Math.max(Number(value), 0), 9999) */ : Number(currentItem.qty) || 0;
            currentItem.basicRate = field === 'purchaseCost' ? value : Number(currentItem.basicRate) || 0;
            currentItem.amount = currentItem.qty * currentItem.basicRate;
            /*  currentItem.cGst = ((Number(currentItem.amount)) * Number(currentItem.cgstPercentage) / 100);
             currentItem.sGst = ((Number(currentItem.amount)) * Number(currentItem.sgstPercentage) / 100);
             currentItem.iGst = ((Number(currentItem.amount)) * Number(currentItem.igstPercentage) / 100); */

            currentItem.cGst = currentItem.isOtherState == false ?
                (currentItem.cGst = ((Number(currentItem.qty)) * Number(currentItem.cgstRate)),
                    currentItem.sGst = ((Number(currentItem.qty)) * Number(currentItem.sgstRate)))
                : currentItem.iGst = ((Number(currentItem.qty)) * Number(currentItem.igstRate));

            /*   if (currentItem.isOtherState == false) {
                  currentItem.cGst = ((Number(currentItem.qty)) * Number(currentItem.cgstRate));
                  currentItem.sGst = ((Number(currentItem.qty)) * Number(currentItem.sgstRate));
              } else {
                  currentItem.iGst = ((Number(currentItem.qty)) * Number(currentItem.igstRate));
              } */


            updated[index] = currentItem;
            setProductList(updated);
        }
    };


    const handleSaveButtonClick = async () => {
        console.log("prod", productList);
        const productInvoicetbl = productList.map((product) => ({
            productinvoicemainid: product.productInvoiceMainId,
            productinvoicelineid: product.productInvoiceLineId,
            ordergroupid: product.mainGroupId,
            orderDate2,
            deliveryDate: orderDate2,
            sessionId: sessionId,
            zoneId: orderZoneId,
            counterId: orderCounterId,
            customerId: product.droppingPointId,
            agentId: product.agentId,
            categoryId: product.categoryId,
            gstIn: product.gstIn,
            userId: 0,
            orderType: 1,

            productid: product.productId,
            productname: product.productName,
            productshortname: product.productShortName,
            maingroupid: product.mainGroupId,
            subgroupid: product.subGroupId,
            hsncode: product.hsnCode,
            unitqty: product.unitQty,
            quantity: product.qty,
            unitfactor: product.unitFactor,
            packetpertray: product.packetPerTray,
            basicrateperunit: product.basicRate,
            baseunitid: product.baseUnitId,
            subunitid: product.subUnitId,
            isOtherState: product.isOtherState,
            cgstrateperunit: product.cgstRate,
            sgstrateperunit: product.sgstRate,
            igstrateperunit: product.igstRate,
            cgstpercentage: product.cgstPercentage,
            sgstpercentage: product.sgstPercentage,
            igstpercentage: product.igstPercentage,
            droppingpointid: product.droppingpointId,
            orderNumber,
            isDespatched,
            orderamount: totalAmount,
            receivedAmount,
            discountAmount,
            orderMode: "1",
        }));

        const productInvReceipt = {
            receiptid: receiptId,
            paymentmode: modeOfPayment,
            receiptamount: receivedAmount,
            paymenttype: 1,
            counterId: orderCounterId,
            droppingpointid,
            agentId,
            reference: reference,
            receiptDate: orderDate2,
            orderAmount: totalAmount,
            paymentstatus: 1,
            receiptNumber: "REC001",
        };
        const productInvoice = {
            productInvoicetbl,
            productInvReceipt,
        };
        console.log("productInvoice", productInvoice);


        const isValidOrder = productList.some(product =>
            product.qty > 0
        );

        if (isValidOrder) {
            if (modeOfPayment) {
                if (reference == "" && modeOfPayment == 1 || reference) {
                    if (parseFloat(receivedAmount) >= totalAmount) {
                        setLoadingDetails(false);
                        //setShowModal(true);
                        if (orderDate && customerCode) {
                            setLoadingDetails(true);
                            try {
                                setOrderDate(orderDate);
                                setCustomerCode(customerCode);
                                const response = await postData<any>(
                                    API_END_POINT.ORDER,
                                    "ProductInvoice/SaveProductInvoice",
                                    "POST",
                                    "application/json",
                                    productInvoice
                                );
                                console.log("res", response);
                                //alert(response);
                                if (response.status === 200) {
                                    //alert("Order Saved Successfully.");
                                    const isUpdate = productList.some(
                                        (p) => p.productInvoiceMainId && p.productInvoiceMainId !== 0
                                    );
                                    setIsUpdateMode(isUpdate);
                                    if (isUpdate) {
                                        setModalTitle("Order Updated");
                                        setModalLine1("Order Updated Successfully");
                                    } else {
                                        setModalTitle("Order Successfully");
                                        setModalLine1("Order Saved Successfully");
                                        setModalLine2("Do you want to print this invoice?");
                                    }
                                    const mainid = response.data.result;
                                    console.log("mainid", mainid);
                                    setproductInvoiceMainId(mainid);
                                    setShowModal(true);
                                    setCustomerCode("");
                                    setSessionId(0);
                                    setSubGroupId(0);
                                    setSubGroupProductList([]);
                                    setProductList([]);
                                    setAddedProducts(new Set());
                                } else {
                                    alert("Failed to Confirm the Order.");
                                    //setModeOfPayment(0);
                                    setReceivedAmount("");
                                    setReference('');
                                }
                            } catch (error) {
                                console.error("Error fetching product details:", error);
                            } finally {
                                setLoadingDetails(false);
                            }
                        } else {
                            alert("Please select a customercode");
                        }

                    }
                    else {
                        alert("Please check the Received Amount");
                    }
                }
                else {
                    alert("Please Select a Reference");
                }
            } else {
                alert("Please select a Payment Mode");
            }
        }
        else {
            alert("Please Select a Quantity");

        }



    };

    const handleProceedInvoice = async () => {
        if (productInvoiceMainId > 0) {
            const getPrintProductInvoiceUrl =
                getEndPoint(API_END_POINT.ORDER) +
                `/api/ProductInvoice/GetProductInvoiceforPdf/${productInvoiceMainId}/${orderDate2}`;
            try {
                const response = await getDataWithToken<any>(getPrintProductInvoiceUrl);
                if (response?.data?.result) {
                    const printProductInvoice = response?.data?.result;
                    setProductInvoiceHtml(printProductInvoice);
                    console.log(productInvoiceHtml);
                    await convertHtmlToPdf(printProductInvoice);
                } else {
                    console.error("No invoice data found.");
                }
            } catch (error) {
                console.error("Error fetching data:", error);
                //setShowGrid(false);
            }
        } else {
            alert("Order Failed");
        }
    };

    const convertHtmlToPdf = async (productInvoiceHtml: string) => {
        const element = document.createElement("div");
        element.innerHTML = productInvoiceHtml;
        document.body.appendChild(element);

        const options = {
            filename: "invoice.pdf",
            /*   margin: [10, 10, 10, 10], */
            html2canvas: {
                dpi: 500,
                scale: 5,
                letterRendering: true,
                useCORS: true,
                allowTaint: false,
            },
            jsPDF: {
                unit: "mm",
                format: "a4",
                orientation: "portrait",
                compress: true,
            },
        };
        html2pdf()
            .set(options)
            .from(element)
            //.addImage('../Assets/Images/company_logo.jpg', 'JPEG', 10, 10, 60, 60)
            .save("invoice.pdf")
            .then(() => {
                document.body.removeChild(element);
            })
            .catch((error: any) => {
                console.error("Error while generating PDF:", error);
            });

        setShowModal(false);
    };

    return (
        <>
            {showBrowsePage ? (
                <ProductInvoiceHistoryPage onEdit={handleEditFromHistory} setActivePage={setActivePage} /> // Pass onEdit prop
            ) : (
                <>
                    <div className="fade_rule"></div>
                    <div className="d-flex justify-content-between mt-4 pt-3 pb-3">
                        <div
                            className="d-flex"
                            style={{ marginTop: "-50px", marginLeft: "20px" }}
                        >
                            <div className="me-2" style={{ width: "200px" }}>
                                <label>Order Date</label>
                                <DatePicker
                                    name="orderDate"
                                    selectsMultiple={true}
                                    openToDate={new Date()}
                                    className="form-control ms-auto search-right-align calendarBg"
                                    value={formatDate(orderDate, "dd-MM-yyyy")}
                                    placeholderText="Order"
                                    dateFormat={"dd/MM/yyyy"}
                                    onChange={([date]: any) => {
                                        setOrderDate(date);
                                        handleDateChange(date);
                                    }}
                                />
                            </div>
                            <div className="me-2" style={{ width: "150px" }}>
                                <label>Code *</label>
                                <input
                                    name="customerCode"
                                    value={customerCode}
                                    onChange={handleChange}
                                    className="sessioninput"
                                ></input>
                            </div>
                            <div className="me-2" style={{ width: "200px" }}>
                                <label>Session</label>
                                <select
                                    value={sessionId}
                                    onChange={handlesessiondropdownChange}
                                    className="sessioninput"
                                    style={{ width: "100%" }}
                                >
                                    <option value="0">Please Select</option>
                                    {sessionList.map((option) => (
                                        <option key={option.label} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="me-2">
                                <button
                                    className="btn btn-primary btn-sm"
                                    style={{ height: "36px", marginTop: "20px", marginLeft: "680px" }}
                                    onClick={handleEditBrowse}
                                >
                                    Browse
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="d-flex justify-content-between mt-4 pt-3 pb-3">
                        <div style={{ flex: '0 0 68%', height: 'auto', overflow: 'visible', marginTop: "-43px" }}>
                            {productList.length > 0 && (
                                <><Grid
                                    data={productList.slice(page.skip, page.skip + page.take)}
                                    style={{ height: 'auto' }}
                                    editField='inEdit'
                                    dataItemKey='productId'
                                    pageable={{ pageSizes: [10, 20, 50, 100] }}
                                    //groupable={true}
                                    skip={page.skip}
                                    take={page.take}
                                    total={productList?.length}
                                    onPageChange={(e) => setPage({ skip: e.page.skip, take: e.page.take })}
                                    // className='tableWrapper'
                                    /*  onItemChange={ItemChange} */
                                    onItemChange={handleItemChange}
                                    onRowClick={handleRowClick}
                                >
                                    <Column
                                        title=""
                                        width="50px"
                                        cell={(props) => (
                                            <td>
                                                <button
                                                    className="action-btns k-grid-remove-command"
                                                    onClick={() => handleRemoveProduct(props.dataIndex)}
                                                >
                                                    <DeleteIcon />
                                                </button>
                                            </td>
                                        )} />
                                    <Column field="code" title="Code" width="60px" editable={false} />
                                    <Column field="productName" title="Product Name" width="200px" editable={false} />
                                    <Column field='baseRate' title='Rate' width="100px" editable={false} format="{0:n2}" className="right-align" />
                                    <Column field='qty' title='Qty' width="100px" editable={true} className="right-align"
                                        editor='text' format="{0:n3}"
                                        /*  cell={(props) => (
                                             <td style={{ textAlign: "right" }}>
                                                 {props.dataItem.qty}
                                             </td>
                                         )} */
                                        footerCell={() => (
                                            <td className="footer-align">
                                                {productList.reduce((sum, item) => sum + (Number(item.qty) || 0), 0).toFixed(3)}
                                            </td>
                                        )} />
                                    <Column
                                        field="cGst"
                                        title="CGST"
                                        width="90px"
                                        editable={false}
                                        className="right-align"
                                        format="{0:n2}" />
                                    <Column
                                        field="sGst"
                                        title="SGST"
                                        width="100px"
                                        editable={false}
                                        editor='text'
                                        className="right-align"
                                        format="{0:n2}" />
                                    <Column
                                        field="iGst"
                                        title="IGST"
                                        width="100px"
                                        editable={false}
                                        editor='text'
                                        className="right-align"
                                        format="{0:n2}" />
                                    <Column
                                        field="amount"
                                        title="Amount"
                                        width="100px"
                                        editable={false}
                                        editor='text'
                                        className="right-align"
                                        format="{0:n2}"
                                        // cell={(props) => <td className="right-align">{(parseFloat(props.dataItem.amount) || 0).toFixed(2)}</td>}
                                        footerCell={() => (
                                            <td className="footer-align">
                                                {productList.reduce((sum, item) => sum + (Number(item.amount) || 0), 0).toFixed(2)}
                                            </td>
                                        )} />
                                </Grid>
                                    <div className="d-flex" style={{ marginTop: "20px", marginLeft: "20px" }}>
                                        <div className="me-2" style={{ width: '200px' }}>
                                            <label>Payment Mode</label>
                                            <select
                                                value={modeOfPayment}
                                                onChange={handleModedropdownChange}
                                                className="boothinput"
                                            >
                                                <option value="">Please Select</option>
                                                {modePayment.map((option) => (
                                                    <option key={option.label} value={option.value}>
                                                        {option.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="me-2" style={{ width: '200px' }}>
                                            <label>Reference</label>
                                            <input
                                                name="reference"
                                                className="boothinput"
                                                value={reference}
                                                onChange={handleChange}
                                            ></input>
                                        </div>
                                        <div className="me-2" style={{ width: '200px' }}>
                                            <label>Received Amount</label>
                                            <input
                                                name="receivedAmount"
                                                value={receivedAmount}
                                                onChange={handleChange}
                                                className="boothinput"
                                            ></input>
                                        </div>
                                        <div className="me-2">
                                            <button
                                                className="btn btn-primary btn-sm"
                                                style={{ height: "36px", marginTop: "20px", marginLeft: "50px" }}
                                                onClick={handleSaveButtonClick}
                                            >
                                             {showSave ? "Update" : "Save"}
                                            
                                            </button>
                                        </div>
                                    </div></>

                            )}

                            {/*  <div className="me-2" style={{ width: '150px' }}>
                                    <label>Payment Mode</label>
                                    <select
                                        value={modeOfPayment}
                                        onChange={handleModedropdownChange}
                                        className="boothinput"
                                    >
                                        <option value="">Please Select</option>
                                        {modePayment.map((option) => (
                                            <option key={option.label} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </select>
                                </div> */}
                        </div>



                        <div style={{ flex: '0 0 28%', height: 'auto', marginTop: "-43px" }}>
                            <div className="purchase-order-container" style={{ marginLeft: '-1px' }}>
                                <div className="toolbar">
                                    {/*  <span className="k-spacer"></span> */}
                                    <label htmlFor="SubGroup">
                                        SubGroup:
                                    </label>
                                    <select
                                        value={subGroupId}
                                        onChange={handlesubgroupdropdownChange}
                                        className="sessioninput"
                                        style={{ width: '72%', marginLeft: '15px', marginTop: '10px' }} // Adjust width to 100% for responsiveness
                                    >
                                        <option value="0">Please Select</option>
                                        {subGroupList.map((option) => (
                                            <option key={option.label} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </select>

                                </div>

                                {subGroupProductList.length > 0 && (
                                    <Grid
                                        style={{ marginLeft: '-75px', marginTop: '5px' }}
                                        /*  style={{ minWidth: '500px' }} */
                                        data={subGroupProductList.slice(subGroupPage.skip, subGroupPage.skip + subGroupPage.take)}
                                        skip={subGroupPage.skip}
                                        take={subGroupPage.take}
                                        total={subGroupProductList.length}
                                        pageable={{
                                            pageSizes: [10, 20, 50, 100],
                                            buttonCount: 5,
                                            info: true,
                                            previousNext: true
                                        }}
                                        onPageChange={(e) => setSubGroupPage({ skip: e.page.skip, take: e.page.take })}
                                    >
                                        <Column field="code" title="Code" width="75px" />
                                        <Column field="productName" title="Product Name" width="265px" />
                                        <Column
                                            width="50px"
                                            cell={(props) => {
                                                return (
                                                    <td>
                                                        <button
                                                            style={{ border: "none", background: "transparent", padding: 0 }}
                                                            onClick={() => handleAddButtonClick(props.dataItem)}
                                                        >
                                                            {addedProducts.has(props.dataItem.code) ? <MinusIcon /> : <PlusIcon />}
                                                        </button>
                                                    </td>
                                                );
                                            }} />

                                    </Grid>
                                )}
                            </div>
                        </div>


                        {/*  Modal for Order Confirmation */}
                        <div style={{ marginTop: 15 }}>
                            {/* Modal for Order Confirmation */}
                            <Modal
                                style={{ alignContent: "center" }}
                                show={showModal}
                                onHide={handleCloseModal}
                            >
                                <Modal.Header closeButton>
                                    {/* <Modal.Title>Order Successfully</Modal.Title> */}
                                    <Modal.Title>{modalTitle}</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <h6>{modalLine1}</h6>
                                    <h6>{modalLine2}</h6>
                                </Modal.Body>
                                <Modal.Footer>
                                    {isUpdateMode ? (
                                        <Button variant="primary" onClick={handleEditBrowse}>
                                            OK
                                        </Button>
                                    ) : (
                                        <>
                                            <Button variant="secondary" onClick={handleCloseModal}>
                                                Back
                                            </Button>
                                            <Button
                                                variant="primary"
                                                onClick={handleProceedInvoice}
                                            >
                                                Proceed
                                            </Button>
                                        </>
                                    )}
                                </Modal.Footer>
                            </Modal>
                        </div>
                    </div>

                    {/* Back Button */}
                    <div className="mt-3" style={{ marginLeft: "20px" }}>
                        <button
                            className="btn btn-primary btn-sm"
                            style={{ height: '36px', marginTop: '20px' }}
                            onClick={() => setActivePage("list")}  // Changed from "agentliterorderpage" to "list"
                        >
                            ← Back
                        </button>
                    </div>
                </>
            )}
        </>
    );
};
export default ProductInvoiceEntryPage;